import {Validators, AbstractControl} from "@angular/forms";
/**
 * Created by markush on 9/21/16.
 */

export class CustomValidators {

  public static time(control: AbstractControl): {[key: string]: boolean} {
    if (Validators.required(control) != null) {
      return null;
    }
    let value: string = control.value;
    let res = value.match(/^(\d{1,2}):(\d{2})$/)
    if (res == null || parseInt(res[1]) > 23 || parseInt(res[2]) > 59) {
      return {'time': true}
    }
    return null;
  }

  public static number(control: AbstractControl): {[key: string]: boolean} {
    if (Validators.pattern("\\d+")(control) != null) {
      return {'number': true}
    }
    return null;
  }

  public static oneOf<T>(collection: T[]) {
    return (control: AbstractControl): {[key: string]: boolean} => {
      if (control.value != ""&& control.value != null && collection.indexOf(control.value) < 0 ) {
        return {'oneOf': true}
      }
      return null;
    }
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/CustomValidators.ts